import { Dispatch } from 'redux';

import { RootState } from '../reducers/store';
import { PublicationReducerActionType } from '../reducers/publicationsReducer';
import { ApiPublicationsResponseType } from '../features/Publications/types';
import { PUBLICATIONS_PER_PAGE } from '../features/Publications/PublicationList';

export const LIST_PUBLICATIONS = 'list_publications';
export const DELETE_PUBLICATION = 'delete_publication';
export const ADD_PUBLICATION = 'add_publication';

export const listPublications =
  (page: number, filterType: string, filterSearch: string) =>
  (
    dispatch: Dispatch<PublicationReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { get },
    } = getState();

    get(
      `/back-office/publications?per_page=${PUBLICATIONS_PER_PAGE}&page=${page}${
        filterType && `&types[]=${filterType}`
      }${filterSearch && `&query=${filterSearch}`}`,
      (response: ApiPublicationsResponseType): void => {
        response.data &&
          dispatch({
            type: LIST_PUBLICATIONS,
            payload: {
              items: response.data,
              total: response.metadata?.total_count,
            },
          });
      }
    );
  };

export const addPublication =
  (body: any, successCallback: () => void, failureCallback: () => void) =>
  (
    dispatch: Dispatch<PublicationReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { post, get },
    } = getState();

    post(
      '/news',
      body,
      (publicationId: string) => {
        successCallback();
        get(
          `/news/${publicationId}`,
          (response: ApiPublicationsResponseType): void => {
            dispatch({
              type: ADD_PUBLICATION,
              payload: response.data,
            });
          }
        );
      },
      () => failureCallback()
    );
  };

export const deletePublication =
  (
    id: string,
    model_type: string,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (
    dispatch: Dispatch<PublicationReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { deletion },
    } = getState();

    deletion(
      `/${
        model_type === 'event'
          ? 'events'
          : model_type === 'poll'
          ? 'polls'
          : 'news'
      }/${id}`,
      {},
      () => {
        dispatch({ type: DELETE_PUBLICATION, payload: id });
        successCallback();
      },
      () => failureCallback()
    );
  };

export const updatePublication =
  (
    id: string,
    body: any,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (
    dispatch: Dispatch<PublicationReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { patch },
    } = getState();

    patch(
      `/news/${id}`,
      body,
      () => {
        listPublications(1)(dispatch, getState);
        successCallback();
      },
      () => failureCallback()
    );
  };
